import React, { useEffect, useState } from "react";
import PlotSerivce from "../../../services/plot.service";
import { TFarmDataResponse } from "../../../services/farm.service";
import SpeedoMetersContainer from "../../../global-components/SpeedoMetersContainer";
import { t } from "../../../services/locale.service";

type TProps = {
  plotId: string;
}

const PestSpeedoMeters: React.FC<TProps> = (props) => {
  const { plotId } = props;

  const [pestPredictions, setPestPredictions] = useState<TFarmDataResponse>({});
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchpestPredictions = async () => {
    try {
      const response = await PlotSerivce.getPestPrediction(plotId);

      const farmData = {} as TFarmDataResponse;
      
      response.forEach(data => {
        // Safety check to ensure data exists and has required properties
        if (!data || typeof data !== "object") {
          console.warn("Invalid data item:", data);
          return;
        }

        const hasSpeedoMeterLabels = data?.labels && Array.isArray(data.labels) && data.labels.length > 0;
        const hasSpeedoMeterValue = data.value !== undefined && data.value !== null;

        const hasSpeedoMeterDetails = hasSpeedoMeterLabels && hasSpeedoMeterValue;
        if(hasSpeedoMeterDetails) {
          // Convert colors to grayscale if not applicable
          const processedLabels = data.isApplicable === false 
            ? (data.labels || []).map(label => ({
              ...label,
              labelColor: "#808080", // Gray
              activeBarColor: "#808080" // Gray
            }))
            : (data.labels || []);

          const pestId = data?.oldPestId ?? "";
          
          farmData[pestId] = {
            value: data?.value ?? 0,
            maxValue: data.maxValue ?? 0,
            minValue: data.minValue ?? 0,
            description: data.description ?? "",
            labels: processedLabels,
            color: data.displayName,
            isApplicable: data.isApplicable // Store the applicability status
          };
        }
      });
      setPestPredictions(farmData);

    } catch(error) {
      console.error(error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchpestPredictions();
  }, []);


  if(isError){
    return <p style={{textAlign: "center"}}>{t("Something_went_wrong")}</p>;
  }

  if(isLoading){
    return <p style={{textAlign: "center"}}>{t("Loading")}</p>;
  }

  return (
    <div>
      {
        Object.keys(pestPredictions).length > 0 ? <SpeedoMetersContainer
          farmData={pestPredictions}
          speedoMeterFor="pest"
          plotId={plotId}
        /> : <p style={{textAlign: "center"}}>{t("No_Pest_Predictions")}</p>
      }  
    </div>
  );
};

export default PestSpeedoMeters;